import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQ_ITEMS, X_URL } from "@/data/content";
import PageHero from "@/components/arc/PageHero";
import Reveal from "@/components/arc/Reveal";
import { GlowButton } from "@/components/arc/ui";
import { GlowOrbs } from "@/components/arc/Backdrops";

const FaqItem = ({ item, open, onToggle, index }) => (
  <div className="border-b border-ice/10" data-testid={`faq-item-${index}`}>
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      data-testid={`faq-question-${index}`}
      className="flex w-full items-center justify-between gap-6 py-6 text-left"
    >
      <span className="flex items-baseline gap-4">
        <span className="font-term text-[10px] tracking-[0.3em] text-electric">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className={`font-display text-sm font-bold tracking-[0.1em] transition-colors duration-300 md:text-lg ${open ? "text-ice" : "text-chrome"}`}>
          {item.q}
        </span>
      </span>
      <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.3 }} className="shrink-0 text-electric">
        <Plus className="h-5 w-5" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p className="max-w-3xl pb-7 pl-10 text-sm leading-relaxed text-silver md:text-base" data-testid={`faq-answer-${index}`}>
            {item.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <>
      <PageHero
        index="10"
        eyebrow="FAQ"
        title="FREQUENT TRANSMISSIONS"
        sub="Straight answers about what ARCIMUS is, what it is not, and what is actually live."
      />
      <section className="relative overflow-hidden pb-24 md:pb-36">
        <GlowOrbs />
        <div className="relative mx-auto max-w-4xl px-5 md:px-8" data-testid="faq-list">
          <Reveal>
            <div className="border-t border-ice/10">
              {FAQ_ITEMS.map((item, i) => (
                <FaqItem
                  key={item.q}
                  item={item}
                  index={i}
                  open={openIndex === i}
                  onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
                />
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-14 flex flex-col items-center gap-6 text-center">
              <p className="text-sm text-silver md:text-base">
                Further signals are broadcast through the official channel.
              </p>
              <GlowButton to={X_URL} external testId="faq-x-btn">FOLLOW ON X</GlowButton>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Faq;
